import { render, staticRenderFns } from "./CheckCard.vue?vue&type=template&id=5730776d&"
import script from "./CheckCard.vue?vue&type=script&lang=js&"
export * from "./CheckCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports